import type { SVGProps } from "react";
import * as React from "react";

const SvgAlignRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 11a1 1 0 1 0 0-2zM7 9a1 1 0 0 0 0 2zm14-2a1 1 0 1 0 0-2zM3 5a1 1 0 0 0 0 2zm18 10a1 1 0 1 0 0-2zM3 13a1 1 0 1 0 0 2zm18 6a1 1 0 1 0 0-2zM7 17a1 1 0 1 0 0 2zm14-8H7v2h14zm0-4H3v2h18zm0 8H3v2h18zm0 4H7v2h14z"
    />
  </svg>
);
export default SvgAlignRight;
